import { Controller } from "@hotwired/stimulus";

// Slide-out panel that overlays the entire viewport.
// Listens for "drawer:open" on window so buttons anywhere on the page can trigger it.
export default class extends Controller {
  static targets = ["overlay", "panel"];

  connect() {
    this._boundOpen = () => this.open();
    window.addEventListener("drawer:open", this._boundOpen);
  }

  disconnect() {
    window.removeEventListener("drawer:open", this._boundOpen);
  }

  open() {
    this.overlayTarget.classList.remove("hidden");
    this.panelTarget.classList.remove("translate-x-full");
  }

  close() {
    this.panelTarget.classList.add("translate-x-full");
    this.overlayTarget.classList.add("hidden");
  }

  closeOnSuccess(event) {
    if (event.detail.success) {
      this.close();
    }
  }
}
